// HeroBanner.jsx

import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const HeroBanner = () => {
  const { t } = useTranslation();

  return (
    <section className="hero">
      <div className="hero-content">
        <img
          src="/images/logo/logo-positive.svg"
          alt="All-Voiced logo"
          className="hero-logo"
        />

        <h2 className="hero-subtitle">
          Turning voice perception into structured data
        </h2>

        <p className="hero-text">
          All-Voiced develops and calibrates expert listeners and provides the infrastructure to transform human perception into analyzable, comparable, and reusable voice data for training, research, and clinical voice assessment.
        </p>

        <p className="hero-micro">
          A human-centered foundation for voice science — and for the next generation of voice technology.
        </p>

        {/* 👇 Subtle manifesto link */}
        <p className="hero-manifesto-link">
        <Link to="/listening-revolution">
          {t('discover_manifesto', 'Why listening matters →')}
        </Link>
        </p>

        <div className="web-cta-row">
          <Link to="/services" className="web-button web-button--primary">
            {t('explore_services', 'Explore services')}
          </Link>

          <Link to="/app" className="web-button web-button--secondary">
            {t('access_app', 'Start training')}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HeroBanner;
